"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cacheNotifications = void 0;
exports.cacheNotifications = {
    Crud: 'UxalyticsClient:CRUD',
};
//# sourceMappingURL=cache-notifications.js.map